import superagent from 'superagent'

const toType = (obj) => {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase()
}
const handleResult = (request) => {
  return new Promise((resolve) => {
    request.end((err, res) => {
      if (err) {
        resolve([err.response.body, null])
      } else {
        resolve([null, res.body])
      }
    })
  })
}

const commonHeader = { 'content-Type': 'application/json;chatset=utf-8' }
export default class SuperagentApi {
  constructor({ baseUrl }) {
    this.agent = superagent
    this.baseUrl = baseUrl
  }
  /**
   *
   * @param {String} api 接口路由
   * @param {Object} params1 扩展对象，满足不同类型参数传递，params为url携带参数,headers为自定义头参数
   * @returns
   */
  get(api, { params, headers = commonHeader }) {
    const request = this.agent.get(`${this.baseUrl}${api}`)
    request.set(headers)
    request.query(params)
    return handleResult(request)
  }
  /**
   *
   * @param {String} api 接口路由
   * @param {Object} params1 扩展对象，满足不同类型参数传递，data为body参数，params为url携带参数,headers为自定义头参数
   * @returns
   */
  post(api, { data, params, headers = commonHeader }) {
    let type = 'json'
    if (toType(data) === 'formdata') {
      type = 'form'
    }
    const request = this.agent.post(`${this.baseUrl}${api}`)
    request.type(type)
    request.set(headers)
    request.query(params)
    request.send(data)
    return handleResult(request)
  }
  /**
   *
   * @param {String} api 接口路由
   * @param {Object} params1 扩展对象，满足不同类型参数传递，params为url携带参数,headers为自定义头参数
   * @returns
   */
  delete(api, { params, headers = commonHeader }) {
    const request = this.agent.del(`${this.baseUrl}${api}`)
    request.set(headers)
    request.query(params)
    return handleResult(request)
  }
}
